/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Peripherals from '@appblocks/codegeneration/Peripherals';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const NAME = feature.getSettingValue('NAME');
    const PIN = feature.getSettingValue('PIN');
    const STATE = feature.getSettingValue('STATE');
    const PULL = feature.getSettingValue('PULL');
    const ACTIVE = feature.getSettingValue('ACTIVE');
    const dtsName = `${NAME}_gpio`;

    const peripherals = Peripherals.getPin(PIN, feature.project.device.id)?.peripherals;
    let peripheralPort = '0';
    let gpioNum: string | undefined = '0';
    if (peripherals) {
        peripheralPort = peripherals.filter(p => p.peripheralType === 'gpio')[0].peripheralPort;
        gpioNum = peripherals.filter(p => p.peripheralType === 'gpio')[0].num;
    }

    const featureId = feature.getID();

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `


function ${dtsName}_pressed_handler() {
    /****button_${NAME}_pressed****/
}

function ${dtsName}_released_handler() {
    /****button_${NAME}_released****/
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        id: 'button_triggered',
        template: `
function button_triggered(state, button) {
    /****button_triggered****/
}
    `,
    });

    blocks.push({
        location: 'button_triggered',
        blockType: BlockType.CODE,
        template: `
if (button === '${NAME}') {
    var_${NAME}_set(Number(!(state ^ ${ACTIVE})));
    if (state) {
        ${dtsName}_pressed_handler();
    } else {
        ${dtsName}_released_handler();
    }
}
    `,
    });

    return blocks;
};
